/**
 * SiteTheme — the persisted, serialized theme state stored on `SiteDoc.site`.
 * Minimal authoritative state: Brand (source of truth) + a pinned generation
 * version + an optional sparse override map. `Tokens` are never stored here —
 * they are re-derived by `resolveTokens(ds, theme)`.
 *
 * `generationVersion` pins the `generate()` algorithm per site so improving the
 * generator never silently restyles existing sites (see Local-first plan).
 *
 * `tokenOverrides` is the deferred "Advanced" tier; modelled loosely here (a
 * deep-partial of Tokens) and validated structurally when that tier ships.
 */
import * as Schema from "effect/Schema";
import { BrandInputs } from "./brand.js";
import type { TokenOverrides } from "./tokens.js";

export const SiteTheme = Schema.Struct({
  brand: BrandInputs,
  /** Which `generate()` revision produced this site's tokens. Pinned per site. */
  generationVersion: Schema.Number,
  /** Optional sparse raw-token overrides (Advanced tier — deferred). */
  tokenOverrides: Schema.optional(
    Schema.Object as unknown as Schema.Schema<TokenOverrides>,
  ),
});
export type SiteTheme = Schema.Schema.Type<typeof SiteTheme>;
